const _LStorage = require("./_LStorage");

module.exports = class ReturningUser {
	constructor () {
		this.cleanupLocalStorage();
	}

	cleanupLocalStorage () {
		const userEmail = _LStorage.decrypt__get('iterable/encrypted/Email')
		const userFirstName = _LStorage.decrypt__get(
			'iterable/encrypted/FirstName'
		)
		const userLastName = _LStorage.decrypt__get('iterable/encrypted/LastName')
		const userCountry = _LStorage.decrypt__get('iterable/encrypted/Country')
		const userCompany = _LStorage.decrypt__get('iterable/encrypted/Company')

		if (
			!userEmail ||
			!/^.+@.+$/.test(userEmail) ||
			!userFirstName ||
			!userLastName ||
			!userCountry ||
			!Object.prototype.hasOwnProperty.call(
				JSON.parse(window.atob(window.ITBL.countries)),
				userCountry
			) || !userCompany
		) {
			for(let key in window.localStorage) {
				if (key.startsWith('iterable/encrypted')) {
					localStorage.removeItem(key);
				}
			}
		}
	}
}
